// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"174":"2f37c7b9","725":"89b77b7b"}[chunkId] + ".js";
};